import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { AdvisorQueryParams, AdvisorFilters } from '../advisor.model';

@Component({
    selector: 'ifb-advisor-list-filter-dialog',
    templateUrl: './advisor-list-filter-dialog.component.html',
    standalone: false
})
export class AdvisorListFilterDialogComponent {
  form: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<AdvisorListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group({
      email: this.data.query.email || '',
      fullName: this.data.query.fullName || '',
      uniqueId: this.data.query.uniqueId || '',
      active: this.data.query.active || undefined
    });
  }

  static show(dialog: MatDialog, query: AdvisorQueryParams): Observable<any> {
    return dialog.open(AdvisorListFilterDialogComponent, {
      data: { query },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new AdvisorFilters(formValues));
  }
}
